module.exports = __webpack_public_path__ + "static/media/sunbeam-poster.fd2767b5.jpg";